// @ts-check

import { useEffect, useState } from 'react';
import { initPwd, initValid } from '../data/profileData';
import convertUser from '../libs/convertUser';
import { updateUserApi } from 'api';
import ProfileEnum from 'containers/pages/profile/ts/profileEnum';
import handleValidPassword from '../libs/handleValidPassword';

/**
 * @function useChangePassword
 * @param {ProfileUser} user
 * @param {() => void} onOpen
 * @returns {UseChangePasswordReturn}
 */
function useChangePassword(user, onOpen) {
	const { PASSWORD, CONFIRM_PASSWORD } = ProfileEnum;

	const [canNotSave, setCanNotSave] = useState(true);
	const [pwdObj, setPwdObj] = useState(initPwd);
	const [valid, setValid] = useState(initValid);

	const onReset = () => {
		setPwdObj(initPwd);
		setValid(initValid);
		setCanNotSave(true);
		onOpen();
	};

	const onUpdatePwd = async () => {
		const convertedUser = convertUser(user, pwdObj);
		await updateUserApi(convertedUser);
		onReset();
	};

	/**
	 * @function onHandlePwd
	 * @param {object} event
	 * @returns {void}
	 */
	const onHandlePwd = (event) => {
		const { name, value } = event.target;
		setPwdObj((prev) => ({ ...prev, [name]: value }));
		handleValidPassword(name, value, pwdObj[PASSWORD], pwdObj[CONFIRM_PASSWORD], setValid);
	};

	useEffect(() => {
		const _canNotSave = Object.values(valid).some(({ canNotSave }) => canNotSave === true);
		setCanNotSave(_canNotSave);
	}, [valid]);

	const state = { canNotSave, pwdObj, valid };

	const handler = { onReset, onUpdatePwd, onHandlePwd };

	return { state, handler };
}

export default useChangePassword;
